import { MfaMethod } from 'dashboard/models/user';
import { UserSession } from 'dashboard/models/user-session';
import {
  CurrentUserSessionActions,
  CurrentUserSessionActionType,
} from 'dashboard/redux/actions/current-user-session';

export interface CurrentUserSessionState {
  userSession: UserSession | undefined;
  startedMfaMethod: MfaMethod | undefined;
}

const initialState: CurrentUserSessionState = {
  userSession: undefined,
  startedMfaMethod: undefined,
};

export default (
  state: CurrentUserSessionState = initialState,
  action: CurrentUserSessionActions,
): CurrentUserSessionState => {
  switch (action.type) {
    case CurrentUserSessionActionType.SetUserSession: {
      return {
        ...state,
        userSession: action.payload.userSession,
      };
    }
    case CurrentUserSessionActionType.StartMfaMethod: {
      return {
        ...state,
        startedMfaMethod: action.payload.method,
      };
    }
    case CurrentUserSessionActionType.CancelMfa: {
      return {
        ...state,
        startedMfaMethod: undefined,
      };
    }
    case CurrentUserSessionActionType.ClearSessionState: {
      return initialState;
    }

    default:
      return state;
  }
};
